export enum StepType {
  GuestBook = 'guest-book',
  Flower = 'flowers',
  Card = 'cards',
  MoneyGift = 'gift-money',
  OrderConfirm = 'confirm',
  Checkout = 'checkout',
  CondolenceVideo = 'condolence-video',
}
